import * as types from '../../index';

export const aflt_rateCardsListAction = (data) => {
    return {
    type: types.RATE_CARDS_LIST_AFFILIATE,
    data
    }
};

export const aflt_rateCardsAllAction = (data) => {
    return {
    type: types.RATE_CARDS_ALL_AFFILIATE,
    data
    }
};

export const aflt_rateCardsAddAction = (data) => {
    return {
    type: types.RATE_CARDS_ADD_AFFILIATE,
    data
    }
};

export const aflt_rateCardsUpdateAction = (data) => {
    return {
    type: types.RATE_CARDS_UPDATE_AFFILIATE,
    data
    }
};

export const aflt_rateCardsDeleteAction = (data) => {
    return {
    type: types.RATE_CARDS_DELETE_AFFILIATE,
    data
    }
};

export const aflt_departmentRateCardsListAction = (data) => { 
    return {
    type: types.DEPT_RATECARDS_LIST,
    data
    }
};

export const aflt_departmentRateCardsUpdateAction = (data) => {
    return {
    type: types.DEPT_RATECARDS_UPDATE, 
    data
    }
};

// TO SET DEFAULT RATE CARD ID FROM RATE CARD LISTING WHILE CLICK ON RATE CARD NAME 
export const setDefaultRateCardId = (data) => {
    return {
        type: types.SET_DEFAULT_RATE_CARD_ID,
        data
    }
}; 
